import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { PPalivoEnum } from '@/modules/ciselnik/noveVozy/modelNv/constants';

import { apiProvider } from '../api';
import { CRUMB_LABEL_KEY as crumbLabel, NAME as name } from '../constants';
import { editMutations } from './types';

const edit = {
	OvprijemkaNr: null as number | null,
	OvprijemkaPfx: null as string | null,
	OvvydejkaNr: null as number | null,
	OvvydejkaPfx: null as string | null,
	Spz: null as string | null,
	VozidloId: null as number | null,
	BarvaKod: null as string | null,
	BarvaText: null as string | null,
	KaroserieNr: null as string | null,
	Objem: null as number | null,
	InvDat: null as Date | null,
	InvPoslNc: null as number | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	ModelRok: null as string | null,
	MotorNr: null as string | null,
	Vykon: null as number | null,
	TpNr: null as string | null,
	Typkod: null as string | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	VstupProvId: null as number | null,
	VstupPracId: null as number | null,
	EditPracId: null as number | null,
	EditDat: null as Date | null,
	PovId: null as number | null,
	VyrobekvozOzn: null as string | null,
	VstupDat: null as Date | null,
	Oznam: null as string | null,
	Memo: null as string | null,
	DphSzbOzn: null as number | null,
	OvvydejkaDat: null as Date | null,
	OvprijemkaDat: null as Date | null,
	DoplnekMk: null as string | null,
	OvdruhPzn: null as number | null,
	OvpuvodPzn: null as number | null,
	ProdejDat: null as Date | null,
	KmStav: null as number | null,
	MajiteluPoc: null as number | null,
	Techstavvykp: null as string | null,
	Techstavprod: null as string | null,
	VyrobaRok: null as string | null,
	NcEtax: null as number | null,
	EtaxOdeslDat: null as Date | null,
	EtaxId: null as number | null,
	MistksezPoc: null as number | null,
	PalivoPzn: null as PPalivoEnum | null,
	MotorPopis: null as string | null,
	PneuPopisZ: null as string | null,
	PneuPopisP: null as string | null,
	Stanovst: null as string | null,
	IbsKod: null as string | null,
	EtaxOcenDat: null as Date | null,
	IbsText: null as string | null,
	OvozidloId: null as number | null,
	IbsPrp: null as boolean | null,
	Vybava: null as string | null,
	Havarie: null as string | null,
	HavariePrp: null as boolean | null,
	LakdruhId: null as number | null,
	EmiseosvNr: null as string | null,
	EmiseDat: null as Date | null,
	StkDat: null as Date | null,
	StkplatDat: null as Date | null,
	PrevodKodVymazat: null as string | null,
	KlicuPoc: null as number | null,
	PrevzTpPrp: null as boolean | null,
	PrevzOtpPrp: null as boolean | null,
	PrevzZpzmvPrp: null as boolean | null,
	PrevzPstkPrp: null as boolean | null,
	PrevzPemiPrp: null as boolean | null,
	AplOdeslDat: null as Date | null,
	AplLastupdDat: null as Date | null,
	PrevodStupne: null as number | null,
	DveriPoc: null as number | null,
	AplLeasmoznPrp: null as boolean | null,
	AplLeasprevzPrp: null as boolean | null,
	AplOdstupne: null as number | null,
	AplLsplat1Poc: null as number | null,
	AplLsplat1: null as number | null,
	AplLspat2Poc: null as number | null,
	AplLsplat2: null as number | null,
	KarostypPzn: null as number | null,
	PrevodtypPzn: null as number | null,
	Oc: null as number | null,
	OcEtax: null as number | null,
	OcMin: null as number | null,
	AplOc: null as number | null,
	AplOcProdejce: null as number | null,
	OvkategPzn: null as number | null,
	TypkodText: null as string | null,
	MotorKod: null as string | null,
	PrevodNr: null as string | null,
	IbsMarketkod: null as number | null,
	VyrobaOd: null as Date | null,
	VyrobaDo: null as Date | null,
	VyrobaDat: null as Date | null,
	PrevodKod: null as string | null,
	OvpuvodvykupuPzn: null as number | null,
	Tablpoz: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel,
	depTableNames: [],
	depTableSettings: {},
	dropdownList: {
		SkladOv: [],
		VyrobekvozOzn: [],
		DphSzbOzn: [],
		OvdruhPzn: [],
		Palivo: [],
		OvpuvodPzn: [],
		PrevodtypPzn: [],
		KarostypPzn: [],
		OvkategPzn: [],
		OvpuvodvykupuPzn: [],
		Stanoviste: [],
		VstupProvId: [],
	},
	edit,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.MODEL_NV_SELECT](state, { data }) {
			state.edit.VyrobekvozOzn = data.vyrobekvozOzn;
			state.edit.Typkod = data.typkod;
			state.edit.TypkodText = data.text;
			state.edit.PalivoPzn = data.palivoPzn;
			state.edit.Tablpoz = data.tablpozice;
			state.edit.Vykon = data.vykon;
			state.edit.Objem = data.objem;
			state.edit.ModelRok = data.modelRok;
			state.edit.DoplnekMk = data.doplnekMk;
		},
		[editMutations.MODEL_OV_SELECT](state, { data }) {
			state.edit.IbsKod = data.ibsKod;
			state.edit.IbsText = data.text;
		},
		[editMutations.PRODAVAJICI_SELECT](state, { data }) {
			state.edit.ZakaznikId = data.value;
			state.edit.ZakaznikIdText = data.text;
		},
		[editMutations.PNEU_POPIS_SELECT](state, { data }) {
			(state.edit as any)[data.valueStoreKey] = data.pneuPopis;
		},
		[editMutations.NAKLADOVE_STREDISKO_SELECT](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.VstupProvId = data.provozovnaId;
			}
		},
	},
	localState: {},
	props: {
		mode: null,
	},
});
